module.exports = __webpack_public_path__ + "img/index_orders_tab.fa5e6f25.gif";